var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPennant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 496C64 504.836 56.836 512 48 512H16C7.164 512 0 504.836 0 496V32C0 14.328 14.326 0 32 0S64 14.328 64 32V496ZM62.736 25.734C63.168 27.828 64 29.777 64 32V26.199L62.736 25.734ZM496.297 185.469L96 37.992V378.012L496.297 230.531C505.734 227.031 512 218.062 512 208S505.734 188.969 496.297 185.469Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPennant);
export default __webpack_public_path__ + "static/media/flag-pennant.cd3c1c26a35a248b99dff81e56600ca7.svg";
export { ForwardRef as ReactComponent };